import { applicationTypes } from '../models/common.ts'
import {
  vObject,
  vObjectId,
  type vOutput,
  vPicklist,
} from '../validation/index.ts'

export const viewAsSchema = vObject({
  application: vPicklist(applicationTypes),
  userId: vObjectId(),
})

export type ViewAsRequest = vOutput<typeof viewAsSchema>
export interface ViewAsResponse {
  token?: string
  success?: boolean
}
